import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		}
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte')
	}
};

export { pageConditions };
